module.exports = __webpack_public_path__ + "img/block21.4dcffe26.png";